import { createStyles, makeStyles, Theme } from '@material-ui/core'

export const useMultiSelectStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            maxWidth: 300,
        },
        chips: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        chip: {
            margin: 2,
            height: 24,
        },
        noLabel: {
            marginTop: theme.spacing(3),
        },
    }),
)
